import { render, staticRenderFns } from "./Autocom.vue?vue&type=template&id=70a34bfe&scoped=true&"
import script from "./Autocom.vue?vue&type=script&lang=js&"
export * from "./Autocom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a34bfe",
  null
  
)

export default component.exports